import React, { useState } from 'react';

export const DriverPool = ({ drivers }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [search, setSearch] = useState('');

  const toggleCollapse = () => setCollapsed(!collapsed);

  const filteredDrivers = drivers.filter(driver => {
    const term = search.toLowerCase();
    return (
      driver.name.toLowerCase().includes(term) ||
      driver.id.toLowerCase().includes(term)
    );
  });

  return (
    <div className={`schedule-management__driver-pool ${collapsed ? 'collapsed' : ''}`}>
      <div className="schedule-management__driver-pool-header">
        <span className="schedule-management__driver-pool-title">Unassigned</span>
        <span className="schedule-management__driver-count">{filteredDrivers.length} available</span>
        <button className="schedule-management__collapse-btn" onClick={toggleCollapse} title="Toggle driver panel">
          <i className={`fa fa-chevron-${collapsed ? 'right' : 'left'}`}></i>
        </button>
      </div>

      {!collapsed && (
        <React.Fragment>
          <input
            type="text"
            className="schedule-management__search-input"
            placeholder="Search drivers..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{ margin: '0 10px 10px' }}
          />

          <div className="schedule-management__driver-list">
            {filteredDrivers.map(driver => {
              const initials = driver.name
                .split(' ')
                .map((n) => n[0])
                .join('')
                .slice(0, 2)
                .toUpperCase();

              return (
                <div key={driver.id} className="schedule-management__driver-card">
                  <div className="schedule-management__driver-avatar">{initials}</div>
                  <div className="schedule-management__driver-info">
                    <div className="schedule-management__driver-name">{driver.name}</div>
                    <div className="schedule-management__driver-id">ID: {driver.id}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </React.Fragment>
      )}
    </div>
  );
};
